import { Controller } from "@hotwired/stimulus"

// The Add block dialog (tasks/_blocks_modal): pick a template, see it filled
// in with today's numbers (GET block_preview, which saves nothing), add it.
// Opened from the list's ⋯ "Add block…" and from "Browse blocks…" in the "/"
// menu (the tasks:browse-blocks window event).
export default class extends Controller {
    static targets = ["item", "preview", "templateId", "add", "search"]
    static values = { previewUrl: String }

    open() {
        window.bootstrap?.Modal.getOrCreateInstance(this.element).show()
    }

    shown() {
        if (!this.templateIdTarget?.value && this.itemTargets.length) this._choose(this.itemTargets[0])
        if (this.hasSearchTarget) this.searchTarget.focus()
    }

    select(e) {
        this._choose(e.currentTarget)
    }

    filter() {
        const query = this.searchTarget.value.trim().toLowerCase()
        let first = null
        this.itemTargets.forEach((item) => {
            const match = !query || item.dataset.label.includes(query)
            item.hidden = !match
            if (match && !first) first = item
        })
        const current = this.itemTargets.find((item) => item.dataset.templateId === this.templateIdTarget.value)
        if (first && (!current || current.hidden)) this._choose(first)
    }

    async _choose(item) {
        this.itemTargets.forEach((other) => other.classList.toggle("is-active", other === item))
        const id = item.dataset.templateId
        this.templateIdTarget.value = id
        this.addTarget.disabled = true
        this.previewTarget.setAttribute("aria-busy", "true")
        try {
            const res = await fetch(`${this.previewUrlValue}?template_id=${encodeURIComponent(id)}`, { headers: { Accept: "text/html" }, credentials: "same-origin" })
            const html = await res.text()
            // A slower answer for a template picked earlier must not win.
            if (this.templateIdTarget.value !== id) return
            if (res.ok) {
                this.previewTarget.innerHTML = html
                this.addTarget.disabled = false
            } else {
                this.previewTarget.textContent = html || "Couldn't build the preview."
            }
        } catch (_error) {
            this.previewTarget.textContent = "Couldn't build the preview."
        } finally {
            this.previewTarget.removeAttribute("aria-busy")
        }
    }
}
